"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTooltipSnapEnableSelector = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var compute_series_geometries_1 = require("./compute_series_geometries");
var get_tooltip_snap_1 = require("./get_tooltip_snap");
exports.isTooltipSnapEnableSelector = (0, create_selector_1.createCustomCachedSelector)([compute_series_geometries_1.computeSeriesGeometriesSelector, get_tooltip_snap_1.getTooltipSnapSelector], function (seriesGeometries, snap) { return (seriesGeometries.scales.xScale && seriesGeometries.scales.xScale.bandwidth > 0) || snap; });
//# sourceMappingURL=is_tooltip_snap_enabled.js.map